var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',_vm._l((_vm.offerPhotos),function(item,i){return _c('v-carousel-item',{key:i,class:{ video: item.type == 'video' },style:(_vm.makeStyle(item)),attrs:{"src":item.src}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }